import { Component, OnInit, Inject } from '@angular/core';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-crwarning',
  templateUrl: './crwarning.component.html',
})
export class CRWarningComponent implements OnInit {
  errorList: ErrorList[] = [];
  enforceRule: string;
  retVal: string;
  errorTitle: string;
  constructor(
    public crWarningDialogRef: MatDialogRef<CRWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.errorTitle = this.data.errorTitle;
    if (!this.errorTitle) {
      this.errorTitle = 'Changes have been entered but not saved.';
    }

    this.errorList = this.data.errorList;
    this.enforceRule = this.data.enforceRule;
  }
  cancelClick() {
    this.retVal = 'Cancel was clicked';
    this.crWarningDialogRef.close(this.retVal);
  }
  saveAnywayClick() {
    this.retVal = 'Save Anyway was clicked';
    this.crWarningDialogRef.close(this.retVal);
  }
}
